<template>
  <div id="app">
    <Nav></Nav>
    <AcceptRequestModal></AcceptRequestModal>
    <NotificationModal></NotificationModal>
    <transition name="fade" mode="out-in">
    <router-view />
    </transition>
    <GoogleAnalytics></GoogleAnalytics>
  </div>
</template>
<script>
import Nav from "@/components/Nav"
import GoogleAnalytics from "@/components/GoogleAnalytics"
import AcceptRequestModal from "@/components/AcceptRequestModal"
import NotificationModal from "@/components/NotificationModal"

export default {
  name:"App",
  components:{Nav, GoogleAnalytics, AcceptRequestModal, NotificationModal},
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Alegreya&family=Alegreya+Sans&family=Merriweather&family=Merriweather+Sans&family=Nunito&family=Nunito+Sans&family=Quattrocento&family=Quattrocento+Sans&family=Roboto&family=Roboto+Mono&family=Roboto+Slab&display=swap');
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
/*
font-family: 'Alegreya', serif;
font-family: 'Alegreya Sans', sans-serif;
font-family: 'Merriweather', serif;
font-family: 'Merriweather Sans', sans-serif;
font-family: 'Nunito', sans-serif;
font-family: 'Nunito Sans', sans-serif;
font-family: 'Roboto', sans-serif;
font-family: 'Roboto Slab', serif;
font-family: 'Roboto Mono', monospace;
font-family: 'Quattrocento', serif;
font-family: 'Quattrocento Sans', sans-serif;
*/
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: 'Nunito', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
h1{
  margin-top:30px;
  margin-bottom:30px;
  font-family: 'Merriweather Sans', sans-serif;
}
h3, h4{
  font-family: 'Merriweather', serif;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.info{
  text-align: left;
  padding:30px;
}
.btn a {
  color:white;
}
.page{
  padding: 30px;
}
h3{
  margin-top:50px;
}
.form-card{
  padding:10px;
  max-width: 500px;
  margin:auto;
}
form{
  text-align:left;
}
.btn-default:not([disabled]):not(.disabled):active{
  background-color:#ffa726 !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
